import React from "react";
import { IconBaseProps } from "react-icons";

export const TranslateSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
  >
    <path d="M23.395 5.86v11.256a2.9 2.9 0 0 1-2.9 2.9h-6.158a.1.1 0 0 0-.06.02l-5.295 3.97a.74.74 0 0 1-1.184-.591v-3.3a.1.1 0 0 0-.1-.1H4.86a2.9 2.9 0 0 1-2.9-2.9V5.86a2.9 2.9 0 0 1 2.9-2.9h15.635a2.9 2.9 0 0 1 2.9 2.9zM8.798 22.895l4.879-3.66a1.1 1.1 0 0 1 .66-.22h6.158a1.9 1.9 0 0 0 1.9-1.9V5.86a1.9 1.9 0 0 0-1.9-1.9H4.86a1.9 1.9 0 0 0-1.9 1.9v11.256c0 1.05.85 1.9 1.9 1.9h2.838a1.1 1.1 0 0 1 1.1 1.1v2.779z" />
    <path d="M17.786 7.109v-1.46h-1.46v1.46h-2.19v1.46h3.618a8.688 8.688 0 0 1-.213 1.319 8.72 8.72 0 0 1-.678 1.849 11.18 11.18 0 0 1-1.347-2.042l-1.298.667.043.084.046.087c.482.9 1.065 1.755 1.757 2.508a9.08 9.08 0 0 1-1.456 1.564 10.07 10.07 0 0 1-.48.38l-.195.139c-.099.068-.099.068-.199.134l.806 1.217a10.615 10.615 0 0 0 2.596-2.43c.365.29.756.547 1.173.758.225.113.457.209.695.293l.483-1.378a4.284 4.284 0 0 1-.449-.183 5.414 5.414 0 0 1-1.098-.717c.427-.76.758-1.574.979-2.42.156-.6.254-1.212.298-1.83h.758v-1.46h-2.189zM8.298 7.839h.963l3.128 7.298H10.8l-.626-1.46H6.422l-.313.73-.313.73H4.208l3.128-7.298h.962zm-1.25 4.379h2.501L8.3 9.298l-1.252 2.92z" />
  </svg>
);
